module.exports = __webpack_public_path__ + "img/header-kbac.4856548a.png";